import { RefObject, useRef } from "react";
import { useTheme } from "@mui/material";
import { useIsomorphicLayoutEffect } from "src/utils/common-util";

export const useResetScrollOnKeyChange = (containerRef: RefObject<HTMLDivElement>, resetScrollKey?: unknown) => {
    const theme = useTheme();
    const hasMountedRef = useRef(false);

    useIsomorphicLayoutEffect(() => {
        if (!hasMountedRef.current) {
            hasMountedRef.current = true;
            return;
        }

        const isMobileViewport = window.matchMedia(theme.breakpoints.down("md").replace("@media ", "")).matches;
        if (isMobileViewport && containerRef.current) {
            containerRef.current.scrollLeft = 0;
        }
    }, [resetScrollKey, theme, containerRef]);
};
